/**
 * Planning table DataDog RUM duration vitals.
 */

import { recordRumDurationVital } from "@/lib/datadog/rumVitals";

export const PLANNING_TABLE_RUM_DURATION_VITALS = {
    /**
     * Wall time for loading planning table data:
     * Starts immediately before `line_orders` loading is set to `true` and ends after materials are
     * loaded, before loading is set to `false`.
     */
    loadTableWallTime: "planning_uc1_wall_table_ms",
    /**
     * Wall time for fully loading planning table UI:
     * Starts immediately before `line_orders` loading is set to `true` (same as `loadTableWallTime`)
     * and ends after the initial short quick sim report is ready.
     */
    loadFullUiWallTime: "planning_uc1_wall_full_ui_ms",
    /**
     * Runtime for synchronizing plan with ERP:
     * Sums the latest measured export/import step durations and excludes user wait time between retries.
     */
    syncPlanWithErpRuntime: "plan_export_build_ms",
} as const;

type VitalContext = {
    orgUuid: string;
    lineGroupUuid: string;
    status?: "error" | "success";
};

type DurationVitalName = (typeof PLANNING_TABLE_RUM_DURATION_VITALS)[keyof typeof PLANNING_TABLE_RUM_DURATION_VITALS];

type DurationVitalPayload = {
    name: DurationVitalName;
    durationMs: number;
    context: VitalContext;
};

/**
 * Records a planning table duration vital with the standard planning table context facets.
 */
export async function recordPlanningTableRumDurationVital(payload: DurationVitalPayload): Promise<void> {
    await recordRumDurationVital({
        name: payload.name,
        durationMs: payload.durationMs,
        context: {
            org_uuid: payload.context.orgUuid,
            line_group_uuid: payload.context.lineGroupUuid,
            status: payload.context.status,
        },
    });
}
